// extracted by mini-css-extract-plugin
module.exports = {"contains":"cross-sell_contains__htnIf","a":"cross-sell_a__2CxHl","_card":"cross-sell__card__tbRz4","_btn":"cross-sell__btn__HRrCR","_btn_submit":"cross-sell__btn_submit__5so3L"};